import { sessionRole } from './routes';

const BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
export function mobileApiBase() { return /\/api$/i.test(BASE) ? `${BASE}/mobile` : `${BASE}/api/mobile`; }
export async function mobileRequest(path, options = {}) {
  const role = sessionRole();
  const token = localStorage.getItem(role === 'client' ? 'clientToken' : 'accessToken');
  if (!role || !token) throw new Error('Please sign in to use notifications.');
  const response = await fetch(`${mobileApiBase()}${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, ...options.headers },
  });
  const data = response.status === 204 ? {} : await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.detail || `Unable to load notifications (${response.status}).`);
    error.status = response.status;
    throw error;
  }
  return data;
}
